package com.neurobs.util

import java.time.LocalDate

import io.circe.{Decoder, Encoder}

import scala.util.Try

class PlainDate private (d: LocalDate) {
	def date: LocalDate = d

	override def toString = d.toString
}

object PlainDate {
	def apply(d: LocalDate): PlainDate = new PlainDate(d)
	def apply(s: String): PlainDate = new PlainDate(LocalDate.parse(s))

	implicit val circeDecoder: Decoder[PlainDate] = Decoder.decodeString.emapTry { str => Try(PlainDate(LocalDate.parse(str))) }
	implicit val circeEncoder: Encoder[PlainDate] = Encoder.encodeString.contramap(_.toString)
}